import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Demand = () => {
    document.title = "Satış";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Satışlar", value: "/demands" },
        { name: "Satış", value: "/demands/demand", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Satış</h2>
                    <p>
                        Satış sənədi, topdan məhsul satışı əməliyyatlarını icra etmək üçün nəzərdə tutulub. Nümunədə satış sənədinin yaradılması göstərilib.
                        <ol>
                            <li>
                                Yeni satış sənədinə lazım olan məlumatları əlavə edərək <SaveButton /> düyməsini sıxın
                            </li>
                            <li>
                                Satış sənədi yadda saxlanıldıqdan sonra, sənədi tərk etmədən yeni sənədlər yarada bilərsiniz. Satış ilə bağlı{" "}
                                <Button>ödəniş</Button>, <Button>qaytarma</Button> sənədlərini yarada bilərsiniz. Bunun üçün <Button>Sənəd yarat</Button>
                                düyməsini sıxıb, təqdim olunan seçimlərdən birini seçmək lazımdır
                            </li>
                            <li>
                                Yadda saxlanılmış sənədi <Button>...</Button> düyməsi ilə silmək olar
                            </li>
                        </ol>
                    </p>
                    <img src="/images/demands/demand-1.gif" alt="Satış" />
                    <img src="/images/demands/demand-2.gif" alt="Satış" />
                </article>
            </div>
        </div>
    );
};
